(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["widgets/update_notice.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div id=\"notice\"><div class=\"box\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "sidebar.update_date_notice"), env.opts.autoescape);
output += "</div></div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
